import { StudentNotesApi, studentsApi } from "api/studentsApi";
import { useEffect, useState } from "react";

export const useStudentNotes = (studentId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<StudentNotesApi[]>([]);

  const fetchNotes = async () => {
    const res = await studentsApi.getNotes(studentId);
    try {
      setData(res.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNotes();
  }, []);

  return { loading, data, refresh: fetchNotes };
};
